<template>
  <div class='h-dialogContainer subnet'>
    <form id='addSubnetForm'>
      <div class='row h-row-inputBox'>
        <div class='col-sm-6 h-col-inputBox'>
          <div>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{this.$t('Topo.subnetName')}}:</div>
            <input class='e-input' name='name' :placeholder='subnetNamePlaceholder' type='text' v-model='subnetInfo.name'/>
          </div>
        </div>
        <div class='col-sm-6 h-col-inputBox-topo'>
          <div class='h-inputLit'>{{this.$t('Topo.subnetDes')}}:</div>
          <ejs-textbox multiline='true' name='description' :placeholder='subnetDescriptionPlaceholder' v-model='subnetInfo.description'></ejs-textbox>
        </div>
        <div class="col-sm-6 h-col-inputBox">
        </div>
      </div>
      <div class='h-topo-trunk'>
        <div class='h-topo-trunka'>
          <div class='h-topo-trunk-neList'>
            {{this.$t('MML.currentNode')}}
          </div>
          <div class='h-topo-trunk-searchbox'>
            <div class='h-topo-trunk-search'>
              <ejs-textbox :placeholder='subnetFilterPlaceHolder' v-model='selectNelistString'></ejs-textbox>
            </div>
            <div class='h-topo-trunk-btn'></div>
          </div>
          <div class='h-topo-grida'>
            <ejs-grid ref='gridA' v-bind:dataSource='searchSelectNeList' :actionComplete='getChooseCountA' height=333 :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
              <e-columns>
                <e-column type='checkbox' headerText='id' width='30' textAlign='Center' :disable='disableFlagA'></e-column>
                <e-column field='id' :headerText="$t('Topo.nodeId')" width='45' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='strType' :headerText="$t('Topo.nodeType')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='name' :headerText="headerTextName" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>

        <div class='h-topo-trunkc'>
          <div class='h-topo-trunk-btnbox'>
            <div class='h-topo-trunkc-btna'>
              <ejs-button cssClass='e-small e-round' iconCss='icon hero-icon hero-icon-add' :title='$t("System.add")'
                          :isPrimary='true' iconPosition='center' @click.native.prevent='add2Subnet'>
              </ejs-button>
            </div>
            <div class='h-topo-trunkc-btnb'>
              <ejs-button cssClass='e-small e-round' iconCss='icon hero-icon hero-icon-remove' :title='$t("System.delete")'
                          :isPrimary='true' @click.native.prevent='delFromSubnet'>
              </ejs-button>
            </div>
          </div>
        </div>

        <div class='h-topo-trunkb'>
          <div class='h-topo-trunk-neList'>
            {{this.$t('Topo.mountNode')}}
          </div>
          <div class='h-topo-trunk-searchbox'>
            <div class='h-topo-trunk-search'>
              <ejs-textbox :placeholder='subnetFilterPlaceHolder' v-model='trunkNelistString'></ejs-textbox>
            </div>
          </div>
          <div class='h-topo-grida'>
            <ejs-grid ref='gridB' v-bind:dataSource='searchSubnetNelist' :actionComplete='getChooseCountB' height=333 :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
              <e-columns>
                <e-column type='checkbox' headerText='id' width='30' textAlign='Center' :disable='disableFlagB'></e-column>
                <e-column field='id' :headerText="$t('Topo.nodeId')" width='45' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='strType' :headerText="$t('Topo.nodeType')" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='name' :headerText="headerTextName" width='60' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
      </div>
      <div class='h-clear-rowMg'></div>
    </form>
  </div>
</template>

<script>
  import { FormValidator } from '@syncfusion/ej2-vue-inputs';
  import { createNamespacedHelpers } from 'vuex';
  import { EventBus } from '../../plugins/eventBus';

  const { mapGetters, mapActions } = createNamespacedHelpers('topoConfig');

  export default {
    name: 'update-subnet',
    components: {
    },
    data() {
      return {
        disableFlagA: false,
        disableFlagB: false,
        //SearchHoder: this.$t('Topo.nodeName'),
        subnetFilterPlaceHolder: this.$t('Topo.subnetFilterPlaceHolder'),
        headerTextName: this.$t('Topo.nodeName'),
        subnetNamePlaceholder: this.$t('Topo.subnetName'),
        subnetTypePlaceholder: this.$t('Topo.subnetType'),
        subnetDescriptionPlaceholder: this.$t('Topo.subnetDes'),
        subnetInfo: {
          id: '',
          name: '',
          type: 0,
          parentId: '',
          positionX: 0,
          positionY: 0,
          children: {},
          description: '',
        },
        visionData: [],
        typeFields: { value: 'value', text: 'typeName' },
        selectNelistString: '',
        trunkNelistString: '',
        selectNelist: [],
        trunkNelist: [],
        readSubnet: true,
        validationOption: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            name: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
              maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
            },
            description: {
              maxLength: [255, `${this.$t('Topo.topoMaxLength')}255`],
            },
          }
        },
      };
    },

    mounted() {
      this.bindValidate();
      // this.initData();
    },
    computed: {
      ...mapGetters(['physicalNodes', 'getPhysicalById', 'getTypeByCode', 'getTopoGraph']),
      // 计算数学，匹配搜索
      searchSelectNeList() {
        let dataList = this.selectNelist;
        let searchString = this.selectNelistString;
        console.log('dataList', dataList);
        if (!searchString) {
          return dataList;
        }
        searchString = searchString.trim().toLowerCase();
        dataList = dataList.filter(item => (
          item.name.trim().toLowerCase().indexOf(searchString) !== -1 || item.strType.trim().toLowerCase().indexOf(searchString) !== -1));
        return dataList;
      },
      searchSubnetNelist() {
        let dataList = this.trunkNelist;
        console.log('addSubnet-trunkNelist', this.trunkNelist);
        let searchString = this.trunkNelistString;
        if (!searchString) {
          return dataList;
        }
        searchString = searchString.trim().toLowerCase();
        dataList = dataList.filter(item => (
          item.name.trim().toLowerCase().indexOf(searchString) !== -1 || item.strType.trim().toLowerCase().indexOf(searchString) !== -1));
        return dataList;
      },
    },
    watch: {
      selectNelistString() {
        this.disableFlagA = true;
      },
      trunkNelistString() {
        this.disableFlagB = true;
      },
    },
    methods: {
      ...mapActions(['setPhysical', 'setLogical', 'setParentNe', 'addParentNe', 'delParentNe']),
      bindValidate() {
        this.formObj = new FormValidator('#addSubnetForm', this.validationOption);
      },
      validate() {
        const formStatus = this.formObj.validate();
        return formStatus;
      },
      // 加子网前初始化
      initData(data, nodes) {
        // 加载同级节点
        if (nodes && nodes.length > 0) {
          const childrenNode = [];
          nodes.forEach(element => {
            if (element.type == 0 || isNaN(element.type)
            	|| (Number(element.type) >= 10004 && Number(element.type) <= 10009)
            	|| (Number(element.type) >= 30001 && Number(element.type) <= 30010) ){
              childrenNode.push(element);
            }
          });
          this.selectNelist = childrenNode;
        }
      },
      // 保存功能,当前子网的parentId和坐标
      outputs(parentId, positionX, positionY) {
        // 表单验证
        if(!this.validate()) {
          return;
        }

        // if(this.trunkNelist.length === 0) {
        //   EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.emptySubnet')});
        //   return;
        // }

        //-- when has subnet , do not found element number
        var containSubnet = false;
        for(var i = 0 ; i < this.trunkNelist.length ;i++)
        {
        	if( this.trunkNelist[i].type == null || Number(this.trunkNelist[i].type) == 0 )
        	{
        		containSubnet = true;
        		break;
        	}
        }

        // if(containSubnet == false && this.trunkNelist.length < 2) {
        //   EventBus.$emit('toast', {type: 'warning', content: this.$t('Topo.SubnetAtLeastTwoNodes')});
        //   return;
        // }

        // 父节点赋值
        if(parentId !== null && parentId !== undefined) {
          this.subnetInfo.parentId = parentId;
        }
        // 坐标赋值
        if(positionX !== null && positionX !== undefined) {
          this.subnetInfo.positionX = positionX;
        }
        if(positionY !== null && positionY !== undefined) {
          this.subnetInfo.positionY = positionY;
        }
        const aSubnet = [],
          // aTrunk = [],
          aDevice = [],
          aDeployEnvironment = [],
          aEnvironment = [],
          map = new Map();
        for (let i = 0; i < this.trunkNelist.length; i++) {
          const node = this.getPhysicalById(this.trunkNelist[i].id.toString());
          if (!node) {
            continue;
          }
          if (isNaN(node.type)) {
            aEnvironment.push(this.trunkNelist[i].id);
          }
          else if (node.type == 0) {
            aSubnet.push(this.trunkNelist[i].id);
          }
          else if ( Number(node.type) >= 30001 && Number(node.type) <= 30010 ) {
            aDeployEnvironment.push(this.trunkNelist[i].id);
          }
          else if (node.type >= 10000 && node.type !== 20001){ // 设备
            aDevice.push(this.trunkNelist[i].id);
          }
        }
        if (aSubnet.length > 0) {
          map.set('Subnet', aSubnet);
        }
        if (aEnvironment.length > 0) {
          map.set('Environment', aEnvironment);
        }
        if(aDeployEnvironment.length > 0)
        {
      		map.set('DeployEnvironment', aDeployEnvironment);
        }
        if (aDevice.length > 0) {
          map.set('Equipment', aDevice);
        }
        this.subnetInfo.children = this.map2Obj(map);
        const params = { ...this.subnetInfo };
        console.log('修改子网请求:', this.subnetInfo);
        this.axios.post('/lte/ems/env/topo/subnet/addSubnet', params).then(response => {
          if (response.data === undefined) {
            return;
          }
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            this.closeWindow();
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
          this.closeWindow();
        });
      },
      closeWindow() {
        this.$emit('close');
      },
      add2Subnet() {
        const This = this;
        const item = this.$refs.gridA.getSelectedRecords();
        for (let i = 0; i < item.length; i++) {
          This.trunkNelist.push(item[i]);
          const index = This.selectNelist.findIndex(v => v.id === item[i].id);
          This.selectNelist.splice(index, 1, { id: '' });
        }
        This.trunkNelist = This.trunkNelist.filter(() => true);
        This.selectNelist = This.selectNelist.filter(val => !(val.id === ''));
      },
      delFromSubnet() {
        const This = this;
        const item = this.$refs.gridB.getSelectedRecords();
        for (let i = 0; i < item.length; i++) {
          This.selectNelist.push(item[i]);
          const index = This.trunkNelist.findIndex(v => v.id === item[i].id);
          This.trunkNelist.splice(index, 1, { id: '' });
        }
        This.selectNelist = This.selectNelist.filter(() => true);
        This.trunkNelist = This.trunkNelist.filter(val => !(val.id === ''));
        console.log('删除子节点:', item);
      },
      // 将选中节点封装, 每次点击添加或移除按钮都向后台发请求
      dealChildren(item) {
        const aSubnet = [];
        const aEquip = [];
        item.forEach(sub => {
          if (sub.typeCode === 0 || sub.typeCode === 1) {
            aSubnet.push(sub.id);
          } else {
            aEquip.push(sub.id);
          }
        });
        const map = new Map();
        if (aSubnet.length > 0) {
          map.set('Subnet', aSubnet);
        }
        if (aEquip.length > 0) {
          map.set('Equipment', aEquip);
        }
        return this.map2Obj(map);
      },
      // 将Map转对象, 为转JSON准备
      map2Obj(mapStr) {
        const newObj = Object.create(null);
        mapStr.forEach((val, index) => {
          newObj[index] = val;
        });
        return newObj;
      },

      makeLayer (arr , id){
        let array = [];
        arr.forEach (function (item, index) {
          if((item.parentid || 0) == id){
            item["child"] = this.makeLayer(arr,item["id"]);
            array.push(item);
          }
        });
        return array;
      },
      getChooseCountA(){
       this.disableFlagA = this.selectNelist.length === 0 ? true : false;
      },
      getChooseCountB(){
        this.disableFlagB = this.trunkNelist.length === 0 ? true : false;
      },
    },
  };
</script>
